import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=75b204ff&scoped=true&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=75b204ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b204ff",
  null
  
)

export default component.exports